module.exports = __webpack_public_path__ + "img/c12.85a71029.png";